import React from 'react';

const FormSkeleton = () => {
  return (
    <div className='space-y-6 py-4'>
      {/* Header skeleton */}
      <div className='flex items-start justify-between'>
        <div className='flex-1 space-y-3'>
          <div className='h-8 bg-gray-200 rounded w-1/2'></div>
          <div className='h-5 bg-gray-200 rounded w-1/3'></div>
          <div className='h-5 bg-gray-200 rounded w-2/5'></div>
        </div>
        <div className='w-32 h-32 bg-gray-200 rounded-lg'></div>
      </div>

      {/* Description skeleton */}
      <div className='space-y-2'>
        <div className='h-4 bg-gray-200 rounded w-1/4'></div>
        <div className='h-20 bg-gray-200 rounded w-full'></div>
      </div>

      {/* Two column skeleton */}
      <div className='grid grid-cols-2 gap-6'>
        <div className='space-y-2'>
          <div className='h-4 bg-gray-200 rounded w-1/3'></div>
          <div className='h-16 bg-gray-200 rounded w-full'></div>
        </div>
        <div className='space-y-2'>
          <div className='h-4 bg-gray-200 rounded w-1/3'></div>
          <div className='h-16 bg-gray-200 rounded w-full'></div>
        </div>
      </div>

      {/* Pills skeleton */}
      <div className='grid grid-cols-3 gap-6'>
        {[1, 2, 3].map((i) => (
          <div key={i} className='space-y-2'>
            <div className='h-4 bg-gray-200 rounded w-1/2'></div>
            <div className='flex flex-wrap gap-2'>
              <div className='h-8 bg-gray-200 rounded-full w-24'></div>
              <div className='h-8 bg-gray-200 rounded-full w-32'></div>
              <div className='h-8 bg-gray-200 rounded-full w-28'></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormSkeleton;
